import { IAuctionStrategy } from '../../../../../redux/reducers';
import { IAuctionStrategyInfoSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';

export function mapAuctionStrategy(auctionStrategyInfo?: IAuctionStrategyInfoSchema | null): IAuctionStrategy {
  const { isEnabled, serviceTypes, strategyName } = auctionStrategyInfo || {};

  return {
    isEnabled: isEnabled || false,
    serviceTypes: serviceTypes || [],
    strategyName: strategyName || '',
  };
}
